import { Observable, of } from 'rxjs';
import { map, tap, switchMap, take } from 'rxjs/operators';

import { PageConfig, Endpoint, CentralApis } from '../interfaces/internal';
import { PageTitles } from '../interfaces/types';
import { Page } from './page';
import { Address } from '../models/address';
import { Result } from '../interfaces/helpers';
import { IAddress } from '../interfaces/models';

export class AddressPage extends Page<Address> {
  constructor({ endpoint }: Endpoint, config: PageConfig) {
    const url = (endpoint as CentralApis).territory + 'territory';
    super(url, PageTitles.address360, config);

    this.initializeColumns({ keys: new Address() });
  }

  fetch(queryString?): Observable<Result<Address>> {
    return this.getItems<Result<Address>>(queryString).pipe(
      take(1),
      tap(({ items }) => {
        this.pageItems.next(items);
      })
    );
  }

  fetchById(id: string): Observable<Address> {
    return this.getItem(id).pipe(
      map((data: IAddress) => this.createFromDTO(data))
    );
  }

  update(item: IAddress): Observable<Address> {
    let updatedAddress: Address[];

    return this.items.pipe(
      take(1),
      switchMap((address) => {
        if (!address || address.length <= 0) {
          return this.fetch().pipe(map(({ items }) => items));
        } else {
          return of(address);
        }
      }),
      switchMap((address) => {
        const addressIndex = address.findIndex((i) => i.id === item.id);
        updatedAddress = [...address];
        const oldAddress = updatedAddress[addressIndex];
        updatedAddress[addressIndex] = this.createFromDTO({
          id: oldAddress.id,
          // eslint-disable-next-line id-blacklist
          number: item.number,
          unit: item.unit,
          streetAddress: item.streetAddress,
          city: item.city,
          clli: item.clli,
          internet: item.internet,
          tv: item.tv,
          date: new Date(item.date),
        });

        return this.updateItems(updatedAddress[addressIndex]);
      }),
      tap(() => {
        this.pageItems.next(updatedAddress);
      })
    );
  }

  createFromDTO(item): Address {
    return Address.createFromDTO(item);
  }
}
